import React from "react";
import { ICON_OPTIONS, iconFor } from "@/lib/icons";

const inputBase =
    "w-full border border-slate-300 px-3 py-2 text-[13.5px] focus:outline-none focus:border-teal-600";

export default function IconSelect({ value, onChange }) {
    const Cmp = iconFor(value);
    return (
        <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-9 h-9 bg-slate-900 text-teal-300">
                <Cmp className="w-4 h-4" strokeWidth={1.5} />
            </span>
            <select
                className={inputBase}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">— select icon —</option>
                {ICON_OPTIONS.map((n) => (
                    <option key={n} value={n}>{n}</option>
                ))}
            </select>
        </div>
    );
}
